'use client'

import { redirect } from 'next/navigation'
import { StoreAuth } from '@/store/store.auth'
import { Login } from '../components/DesktopEnglish/login/LoginForm'



export default function LoginPage() {

  // StoreAuth.getState().checkToken()
  const isAuthenticated = (StoreAuth.getState().isAuthenticated)
  // const token = (StoreAuth.getState().token)

  if (isAuthenticated) {
    redirect('/')
  }

  return <Login />
}
